
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 17.251a6.753 6.753 0 0 1 9.4-6.208M3.375 4.876a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 1 0-8.25 0Zm7.875 12.373a6 6 0 1 0 12 0 6 6 0 1 0-12 0Zm8.25-2.251-4.5 4.5m0-4.5 4.5 4.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    